<template>
  <b-modal
      :id="id"
      ref="modal"
      :title="modalTitle"
      centered
      title-class="font-18"
      v-bind="$attrs"
  >
    <div v-if="loading" class="d-flex justify-content-center py-4">
      <i class="bx bx-loader bx-spin font-size-24 align-middle"></i>
    </div>
    <div v-else-if="model">
      <div class="row">
        <b-form-group
            class="col-6 mb-3"
            label-cols-md="12"
            :label="lodash.startCase($t('jala_users.name'))"
        >
          <span>{{ model.name || '-' }}</span>
        </b-form-group>
        <b-form-group
            class="col-6 mb-3"
            label-cols-md="12"
            :label="lodash.startCase($t('jala_users.email'))"
        >
          <span>{{ model.email || '-' }}</span>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
            class="col-6 mb-3"
            label-cols-md="12"
            :label="lodash.startCase($t('jala_users.phone'))"
        >
          <span>{{ model.phone || '-' }}</span>
        </b-form-group>
        <b-form-group
            class="col-6 mb-3"
            label-cols-md="12"
            :label="lodash.startCase($t('jala_users.position'))"
        >
          <span>{{ model.position || '-' }}</span>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
            class="col-6 mb-3"
            label-cols-md="12"
            :label="lodash.startCase($t('jala_users.role'))"
        >
          <span>{{ rolesLabel }}</span>
        </b-form-group>
        <b-form-group
            class="col-6 mb-3"
            label-cols-md="12"
            :label="lodash.startCase($t('models.created_at'))"
        >
          <span>{{ $moment(model.created_at).format('DD MMM, YYYY') }}</span>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
            class="col-6 mb-3"
            label-cols-md="12"
            :label="lodash.startCase($t('users.is_active'))"
        >
          <status-badge
              entity="user"
              type="status"
              :status="model.is_active ? 'active' : 'inactive'"
          >
            {{ model.is_active ? lodash.startCase($t('users.active')) : lodash.startCase($t('users.inactive')) }}
          </status-badge>
        </b-form-group>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="md" variant="outline-dark" style="border: 1px solid #D0D5DD" @click="cancel()">Tutup</b-button>
      <b-button size="md" variant="primary" style="background: #FDB022;border: none;" @click="handleEdit">Ubah</b-button>
    </template>
  </b-modal>
</template>

<script>
import StatusBadge from "@/components/badges/status-badge.vue";
import Swal from "sweetalert2";

export default {
  name: "user-show-modal",
  components: { StatusBadge },
  props: {
    id: { type: String, required: true },
    modalTitle: {
      default() {
        return this.lodash.startCase(this.$t("jala_users.singular"));
      },
    },
  },
  data() {
    return {
      loading: false,
      model: null,
      userId: null,
    };
  },
  computed: {
    rolesLabel() {
      if (!this.model || !this.model.roles || !this.model.roles.length) return '-';
      return this.model.roles
        .map((r) => this.lodash.upperFirst(this.$t(`users.roles.${r.name || 'admin'}`)))
        .join(', ');
    },
  },
  methods: {
    show(userId) {
      this.model = null;
      this.userId = userId;
      this.$bvModal.show(this.id);
      this.fetchModel(userId);
    },
    handleEdit() {
      this.$refs.modal.hide();
      this.$emit('edit', this.model);
    },
    fetchModel(userId) {
      this.loading = true;
      return this.$axios
        .get(`/users/${userId}`, { params: { with: 'roles' } })
        .then((response) => {
          const { data: { data } } = response;
          this.model = data;
          return response;
        })
        .catch((error) => {
          Swal.fire({
            title: this.$t('Failed') + '!',
            text: (error.response && error.response.data && error.response.data.message) || error.message,
            type: 'danger',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-title {
    font-weight: 800;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    color: #0084f3;
  }

  .modal-dialog {
    max-width: 540px !important;
  }

  .col-form-label {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #182230;
  }

  .form-row > .col {
    color: #0F172A;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>
